import { Map } from 'immutable';
import { combineImmutableReducers } from '../../util';

const DEFAULT_CATEGORIES = new Map();

// Reducer to track individual Comments by ID
function byId(state = DEFAULT_CATEGORIES, action) {
  if (action.response && action.response.entities && action.response.entities.users) {
    if (action.response && action.response.entities && action.response.entities.categories) {
        return state.merge((new Map(action.response.entities.categories)).map(c => new Map(c)));
    }
  }
  return state;
}

// Build our reducer using `combineImmutableReducers`
const reducer = combineImmutableReducers({
  byId
});

export default reducer;

export const getCategories = (state) => {
  return state.get("byId").sort();
}




// WEBPACK FOOTER //
// ./src/snapit_app/reducers/categories.js